const ForecastTable = ({ data }) => {
  return (
    <table className="table table-bordered mt-4">
      <tbody>
        <tr>
          <th>SKU</th>
          <td>{data.sku}</td>
        </tr>
        <tr>
          <th>Warehouse</th>
          <td>{data.warehouse_id}</td>
        </tr>
        <tr>
          <th>Stockout Date</th>
          <td className="text-warning">{data.stockout_date}</td>
        </tr>
      </tbody>
    </table>
  );
};

export default ForecastTable;
